// extracted by mini-css-extract-plugin
module.exports = {"registrationPage":"style__registrationPage__8J2+j"};